import React from 'react';
import {alpha, Box, Divider, Paper, Stack, Typography} from '@mui/material';
import {CheckCircle, Label, } from '@mui/icons-material';

function SmartLabellingVisual() {
    return (<Box
        sx={{
            width: '100%', height: '100%', minHeight: 330, p: 2.5, bgcolor: 'background.paper', display: 'flex', alignItems: 'center',
        }}
    >
        <Paper
            variant="outlined"
            sx={{
                width: '100%', borderRadius: 2.5, overflow: 'hidden', bgcolor: 'background.paper', boxShadow: '0 16px 32px rgba(15, 23, 42, 0.05)',
            }}
        >
            {/* Header */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider',
                }}
            >
                <Stack direction="row" spacing={1} alignItems="center">
                    <Box
                        sx={{
                            width: 30, height: 30, borderRadius: '50%', bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1), color: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                    >
                        <Label sx={{fontSize: 17}}/>
                    </Box>

                    <Box>
                        <Typography variant="subtitle2" sx={{fontWeight: 800}}>
                            Smart labelling
                        </Typography>
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{display: 'block', mt: 0.25}}
                        >
                            EU-oriented label draft
                        </Typography>
                    </Box>
                </Stack>

            </Stack>

            <Box
                sx={{
                    display: 'grid', gridTemplateColumns: {xs: '1fr', sm: '1.55fr 1fr'}, minHeight: 250,
                }}
            >
                {/* Label preview */}
                <Box sx={{p: 2.25}}>
                    <Typography
                        variant="caption"
                        sx={{
                            display: 'block', mb: 1, fontWeight: 800, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.4,
                        }}
                    >
                        Ingredients Label Preview
                    </Typography>

                    <Paper
                        variant="outlined"
                        sx={{
                            p: 2, borderRadius: 2, bgcolor: (theme) => alpha(theme.palette.grey[500], 0.035),
                        }}
                    >
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{display: 'block', mb: 0.5, fontWeight: 700}}
                        >
                            Ingredients
                        </Typography>

                        <Typography
                            variant="caption"
                            sx={{
                                display: 'block', lineHeight: 1.45, fontWeight: 400, color: 'text.primary', mb: 1.5, '& strong': {
                                    fontWeight: 800,
                                },
                            }}
                        >
                            <strong>Milk</strong> (Cow) (78.500%), Canada blueberry (10.000%), Whole Milk Powder (7.000%), Yogurt (4.100%), Pectin (0.400%)
                        </Typography>

                        <Divider sx={{my: 1.25}}/>

                        <Stack spacing={1}>
                            <Box>
                                <Typography
                                    variant="caption"
                                    sx={{display: 'block', fontWeight: 800}}
                                >
                                    Contains:
                                </Typography>

                                <Typography
                                    variant="caption"
                                    sx={{
                                        display: 'block', color: 'error.main', fontWeight: 800, lineHeight: 1.35,
                                    }}
                                >
                                    Milk and products thereof
                                </Typography>
                            </Box>

                            <Box>
                                <Typography
                                    variant="caption"
                                    sx={{display: 'block', fontWeight: 800}}
                                >
                                    May contain:
                                </Typography>

                                <Typography
                                    variant="caption"
                                    sx={{
                                        display: 'block', color: 'warning.main', fontWeight: 800, lineHeight: 1.35,
                                    }}
                                >
                                    Nuts and products thereof
                                </Typography>
                            </Box>
                        </Stack>
                    </Paper>
                </Box>

                {/* Validation/status panel */}
                <Box
                    sx={{
                        p: 2.25, borderLeft: {sm: '1px solid rgba(15, 23, 42, 0.08)'}, borderColor: 'divider', bgcolor: (theme) => alpha(theme.palette.primary.main, 0.018),
                    }}
                >
                    <Typography
                        variant="caption"
                        sx={{
                            display: 'block', mb: 1.5, fontWeight: 800, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.4,
                        }}
                    >
                        Label checks
                    </Typography>

                    <Stack spacing={1.25}>
                        {['Ingredient list generated', 'Allergens highlighted', 'Label version tracked',].map((item) => (<Stack key={item} direction="row" spacing={1} alignItems="center">
                            <CheckCircle sx={{fontSize: 16, color: 'success.main'}}/>
                            <Typography variant="caption" sx={{fontWeight: 700}}>
                                {item}
                            </Typography>
                        </Stack>))}
                    </Stack>
                </Box>
            </Box>
        </Paper>
    </Box>);
}

export default SmartLabellingVisual;